import React from "react";
import nodejs from "../../Images/Blog/node.png";
import reactTesting from "../../Images/Blog/react-testing.webp";
import redux from "../../Images/Blog/react-typescript.png";
import reactjs from "../../Images/Blog/reactjs.jpg";
import AllBlogs from "./AllBlogs";

const Blogs = () => {
  const blogs = [
    {
      title: "What is React JS ?",
      img: reactjs,
      des: "If you want learn React Js. This blog might helps you to gain some basic knowledge about React.",
      link: "https://dev.to/lukmanhossain/react-blog-1je2",
    },
    {
      title: "What is Node JS ?",
      img: nodejs,
      des: "If you want learn Node Js. This blog might helps you to gain some basic knowledge about Node JS.",
      link: "https://dev.to/lukmanhossain/node-blog-aa5",
    },
    {
      title: "Redux, Typescript Blog",
      img: redux,
      des: "If you want learn Redux, Typescript, Webpack, WebSocket and Base64. This blog might helps you.",
      link: "https://dev.to/lukmanhossain/what-is-are-redux-typescript-webpack-websocket-and-base64-how-we-install-or-use-in-our-new-and-existing-project-5792",
    },
    {
      title: "Importance of React Testing Library !",
      img: reactTesting,
      des: "If you want learn React Testing Library. This blog might helps you.",
      link: "https://dev.to/lukmanhossain/react-testing-library-setup-why-it-is-important-in-react-45gm",
    },
  ];
  return (
      <div className="container text-center mt-4 pt-5">
        <h1 className="blogs-section mb-4 pb-3">My Some Blogs !</h1>
        <div className="row text-center ">
          {blogs.map((blog) => (
            <AllBlogs blog={blog}></AllBlogs>
          ))}
        </div>
      </div>
  );
};

export default Blogs;
